export interface PanBounds {
  minPositionX: number
  maxPositionX: number
  minPositionY: number
  maxPositionY: number
}

export const MINIMAP_ALIGNMENT_PADDING_PX = 100

export function getPanBounds(
  wrapperW: number,
  wrapperH: number,
  contentW: number,
  contentH: number,
  centerZoomedOut = false
): PanBounds {
  const diffWidth = wrapperW - contentW
  const diffHeight = wrapperH - contentH
  const scaleWidthFactor =
    wrapperW > contentW ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0
  const scaleHeightFactor =
    wrapperH > contentH ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0

  return {
    minPositionX: wrapperW - contentW - scaleWidthFactor,
    maxPositionX: scaleWidthFactor,
    minPositionY: wrapperH - contentH - scaleHeightFactor,
    maxPositionY: scaleHeightFactor,
  }
}

export function clampPanPosition(
  positionX: number,
  positionY: number,
  bounds: PanBounds,
  paddingPx = 0
): { positionX: number; positionY: number } {
  const minX = bounds.minPositionX - paddingPx
  const maxX = bounds.maxPositionX + paddingPx
  const minY = bounds.minPositionY - paddingPx
  const maxY = bounds.maxPositionY + paddingPx

  return {
    positionX: Math.min(maxX, Math.max(minX, positionX)),
    positionY: Math.min(maxY, Math.max(minY, positionY)),
  }
}

export function panFromMinimapDrag(args: {
  startPosX: number
  startPosY: number
  startClientX: number
  startClientY: number
  clientX: number
  clientY: number
  minimapScale: number
  documentScale: number
}): { positionX: number; positionY: number } {
  if (args.minimapScale === 0) {
    return { positionX: args.startPosX, positionY: args.startPosY }
  }
  const imgDx = (args.clientX - args.startClientX) / args.minimapScale
  const imgDy = (args.clientY - args.startClientY) / args.minimapScale
  return {
    positionX: args.startPosX - imgDx * args.documentScale,
    positionY: args.startPosY - imgDy * args.documentScale,
  }
}
